import React from 'react';
import { getJananiData } from '../../../../services/adminService';
import JananiDataTable from './JananiDataTable';
import JananiVisualInsights from './JananiVisualInsights';
import DataPoints from '../DataPoints';
import { exportToCSV } from '../../../../utils/exportUtils';

const cohorts = [
    { label: "Pregnancy", non: "preg_non_anaemic", mild: "preg_mild", mod: "preg_moderate", sev: "preg_severe" },
    { label: "Lactating Women", non: "lactating_non_anaemic", mild: "lactating_mild", mod: "lactating_moderate", sev: "lactating_severe" },
    { label: "IFA Tabs (ANC)", non: "ifa_anc_non_anaemic", mild: "ifa_anc_mild", mod: "ifa_anc_moderate", sev: "ifa_anc_severe" },
    { label: "IFA Tabs (PNC)", non: "ifa_pnc_non_anaemic", mild: "ifa_pnc_mild", mod: "ifa_pnc_moderate", sev: "ifa_pnc_severe" }
];

const calculateTotalsFn = (chartRecords) => {
    let non = 0, mild = 0, mod = 0, sev = 0;
    chartRecords.forEach((r) => {
        cohorts.forEach((c) => {
            non += Number(r[c.non] || 0);
            mild += Number(r[c.mild] || 0);
            mod += Number(r[c.mod] || 0);
            sev += Number(r[c.sev] || 0);
        });
    });
    return { non, mild, mod, sev };
};

const exportCSVFn = (localData, sourceName) => {
    const headers = [
        "ID", "Reporting Date", "State Name", "District Name",
        "Pregnancy Non Anaemic", "Pregnancy Mild", "Pregnancy Moderate", "Pregnancy Severe",
        "Severe Treatment Iron Supplements", "Severe Treatment Iron Sucrose", "Severe Treatment Blood Transfusion", "Severe Treatment Not Treated",
        "IFA ANC Non Anaemic", "IFA ANC Mild", "IFA ANC Moderate", "IFA ANC Severe",
        "Lactating Non Anaemic", "Lactating Mild", "Lactating Moderate", "Lactating Severe",
        "IFA PNC Non Anaemic", "IFA PNC Mild", "IFA PNC Moderate", "IFA PNC Severe"
    ];

    const fields = [
        "id", "report_date", "state_name", "district_name",
        "preg_non_anaemic", "preg_mild", "preg_moderate", "preg_severe",
        "sev_anc_iron_supplements", "sev_anc_iron_sucrose_inj", "sev_anc_blood_transfusion", "sev_anc_not_treated",
        "ifa_anc_non_anaemic", "ifa_anc_mild", "ifa_anc_moderate", "ifa_anc_severe",
        "lactating_non_anaemic", "lactating_mild", "lactating_moderate", "lactating_severe",
        "ifa_pnc_non_anaemic", "ifa_pnc_mild", "ifa_pnc_moderate", "ifa_pnc_severe"
    ];

    exportToCSV(localData, sourceName, headers, fields);
};

const fetchJananiNormalized = async (...args) => {
    const res = await getJananiData(...args);
    if (res && res.chartData && res.chartData.overallTotals) {
        const ot = res.chartData.overallTotals;
        // Ensure total_normal, total_mild, etc., exist for DataPoints.jsx top cards
        if (ot.total_normal === undefined && ot.total_non_anaemic === undefined) {
            ot.total_normal = (ot.preg_non_anaemic || 0) + (ot.lactating_non_anaemic || 0) + (ot.ifa_anc_non_anaemic || 0) + (ot.ifa_pnc_non_anaemic || 0);
            ot.total_mild = (ot.preg_mild || 0) + (ot.lactating_mild || 0) + (ot.ifa_anc_mild || 0) + (ot.ifa_pnc_mild || 0);
            ot.total_moderate = (ot.preg_moderate || 0) + (ot.lactating_moderate || 0) + (ot.ifa_anc_moderate || 0) + (ot.ifa_pnc_moderate || 0);
            ot.total_severe = (ot.preg_severe || 0) + (ot.lactating_severe || 0) + (ot.ifa_anc_severe || 0) + (ot.ifa_pnc_severe || 0);
        }
    }
    return res;
};

const JananiDataPoints = ({ onTotalsCalculated }) => {

    return (
        <DataPoints
            sourceName="JANANI"
            fetchDataFn={fetchJananiNormalized}
            onTotalsCalculated={onTotalsCalculated}
            renderVisuals={(chartData, loading) => (
                <JananiVisualInsights chartData={chartData} loading={loading} />
            )}
            renderTable={(records, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage) => (
                <JananiDataTable
                    records={records} loading={loading}
                    currentPage={currentPage} setCurrentPage={setCurrentPage}
                    totalCount={totalCount} totalPages={totalPages} rowsPerPage={rowsPerPage}
                />
            )}
            exportCSVFn={exportCSVFn}
            calculateTotalsFn={calculateTotalsFn}
        />
    );
};

export default JananiDataPoints;
